<template>
    <div class = "container-tabs-container">
      <div class="container-tab" v-bind:class="{ 'container-tab-active': container_view_selected_tab=='actions'}" @click="changeTab('actions')">Acciones</div>
      <div class="container-tab" v-bind:class="{ 'container-tab-active': container_view_selected_tab=='docs'}" @click="changeTab('docs')">Docs</div>
      <div class="container-tab" v-bind:class="{ 'container-tab-active': container_view_selected_tab=='tracking'}" @click="changeTab('tracking')">Tracking</div>
      <div class="container-tab" v-bind:class="{ 'container-tab-active': container_view_selected_tab=='details'}" @click="changeTab('details')">Detalles</div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ContainerActions from '@/components/containerViews/ContainerActions'
import ContainerDocs from '@/components/containerViews/ContainerDocs'
import ContainerTracking from '@/components/containerViews/ContainerTracking'
import ContainerDetails from '@/components/containerViews/ContainerDetails'

export default {
  name: 'ContainerTabs',
  components: {
      ContainerActions,
      ContainerDocs,
      ContainerTracking,
      ContainerDetails
  },
  computed: {
    container_view_selected_tab: {
      set (tab) { this.$store.dispatch('change_container_view_selected_tab', {tab: tab}); },
      get () { return this.$store.state.UI.container_view_selected_tab }
    },
    expedient_id: {
      get () { return this.$store.state.container.container_id }
    },
  },
  mounted () {
    this.$store.commit('set_view_name', [this.expedient_id])
  },
  methods: {
    changeTab: function (tab) {
      if (tab != this.container_view_selected_tab){
        this.container_view_selected_tab = tab
        //this.$store.commit('set_view_name', [this.expedient_id])
      }
    }
  }
}
</script>

<style lang= "scss" scoped>
.container-tabs-container {
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 3px 6px rgba(0,0,0,0.3);
  border-bottom: 1px solid #AAAAAA;
  position: relative;
  z-index: 20;
}
.container-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d1d1d1;
  border: 1px solid #c2c2c2;
  color: #676767;
  font-weight: 600;
  cursor: pointer;
}
.container-tab-active {
  background-color: white;
  cursor: default;
  border: 1px solid white;
}
</style>
